import { FC, useCallback } from 'react'

import { F0WizardForm } from '@factorialco/f0-react'
import type {
  BenefitMemberEnrollmentData,
  IdentifierType,
  PersonalInformationFormData,
} from './types'
import { BenefitsHealthcareEnrollmentPlanFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useHealthcareEnrollmentWizardForm } from './form'

interface Props {
  healthcarePlanData: BenefitsHealthcareEnrollmentPlanFragment
  identifierTypes: IdentifierType[]
  initialPersonalInformationData: PersonalInformationFormData

  onSubmit: (data: BenefitMemberEnrollmentData) => void
  onClose: () => void
}

const HealthcareEnrollmentWizard: FC<Props> = ({
  healthcarePlanData,
  initialPersonalInformationData: personalInformationData,
  identifierTypes,
  onSubmit,
  onClose,
}) => {
  useEffect(() => {
    track(trackingEvents.benefits.openHealthcareEnrollmentWizard)
    track(trackingEvents.benefits.openHealthcareEnrollmentPlanOverviewStep)
  }, [])

  const handleStepChanged = useCallback((step: number) => {
    if (step === 1) {
      track(trackingEvents.benefits.advanceToHealthcareEnrollmentPersonalInformationStep)
    }
  }, [])

  const { formDefinition, steps } = useHealthcareEnrollmentWizardForm({
    healthcarePlanData,
    identifierTypes,
    initialPersonalInformationData: personalInformationData,
    onSubmit,
  })

  return (
    <F0WizardForm
      isOpen
      title={i18n.t('benefits.healthcare.enrollment_wizard.title')}
      width="xl"
      previousLabel={i18n.t('common.back')}
      formDefinition={formDefinition}
      steps={steps}
      onClose={onClose}
      onStepChanged={handleStepChanged}
    />
  )
}

export default HealthcareEnrollmentWizard
